import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20dark%20teal%20geometric%20circuit%20board%20pattern%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20neon%20glowing%20traces%2C%20futuristic%20semiconductor%20design%20concept%2C%20professional%20quality%2C%20no%20text&width=1800&height=600&seq=cta-bg-2048&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/85 via-foreground-900/80 to-foreground-900/90"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <div className="w-14 h-14 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-500/20">
          <i className="ri-cpu-line text-2xl text-primary-400"></i>
        </div>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好拥抱2048核并行计算了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/60 mb-8 max-w-xl mx-auto leading-relaxed">
          无论您是AI训练团队、数据中心架构师，还是HPC应用开发者，
          我们的技术团队都能为您提供专业的2048核方案咨询与部署支持。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors whitespace-nowrap"
          >
            联系我们
          </Link>
          <Link
            to="/categories"
            className="px-7 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-md text-sm backdrop-blur-sm transition-colors whitespace-nowrap"
          >
            浏览技术文档
          </Link>
        </div>
      </div>
    </section>
  );
}